import { useCatalogPageContext } from "shared/catalog/CatalogPageContext/useCatalogPageContext";
import { ArrowSelectorIcon } from "shared/forms/SelectCombo/ArrowSelectorIcon";
import { useI18n } from "utils/with-i18n.utils";

import { CatalogSorting as CatalogSortingType } from "./CatalogPageContext";

export const CatalogSorting = () => {
  const i18n = useI18n();
  const { filteredAvailableEntries = [], filteredComingSoonEntries = [], sorting, setSorting } = useCatalogPageContext();
  const resultsCount = filteredAvailableEntries.length + filteredComingSoonEntries.length;
  
  return (
    <div className="flex gap-5 justify-end items-center">
      <p><span className="text-lg font-medium">{resultsCount}</span> <span>{i18n.t('catalog.sorting.results')}</span></p>
      <div className="relative">
        <select
          className="py-2.5 px-5 w-48 bg-white rounded-md border border-black/20 outline-black appearance-none cursor-pointer"
          value={sorting}
          onChange={(e) => setSorting(e.target.value as CatalogSortingType)}
        >
          <option value="default">{i18n.t('catalog.sorting.opt.default')}</option>
          <option value="price-asc">{i18n.t('catalog.sorting.opt.price-asc')}</option>
          <option value="price-desc">{i18n.t('catalog.sorting.opt.price-desc')}</option>
        </select>  
        <ArrowSelectorIcon className="absolute top-3 right-3" />
      </div>
    </div>
  );
};

